/**
 * Splits a user the app keeps as "Name (email@example.com)" into the two.
 * @param nameString the stored label, which may carry no email at all
 * @returns the name and the email, or null where the label is not that shape
 */
export function splitNameAndEmail(nameString: string | null | undefined): { name: string, email: string } | null {
    const match = nameString ? /^([^(]+)\(([^)]+)\)$/.exec(nameString) : null;
    return match ? {name: match[1].trim(), email: match[2].trim()} : null;
}

/**
 * Parse and format name with email in "name (email)" format
 * Splits into name displayed above email with appropriate CSS classes
 * @param nameString string in format "Name (email@example.com)"
 * @returns JSX element with name and email displayed vertically, or original string if no match
 */
export function formatNameWithEmail(nameString: string | null | undefined): JSX.Element | string {
    if (!nameString) return "";
    const parts = splitNameAndEmail(nameString);
    if (parts) {
        return (
            <div className="d-flex flex-column">
                <span className="text-body">{parts.name}</span>
                <span className="text-body-secondary">{parts.email}</span>
            </div>
        );
    }
    return nameString;
}
